import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';

@Component({
  selector: 'app-manage-pwa',
  templateUrl: './manage-pwa.component.html',
  styleUrls: ['./manage-pwa.component.css']
})
export class ManagePwaComponent implements OnInit {
  manifestUrl;
  assetsUrl;
  btndisabled = false;
  manifestJson = {
    "name": "",
    "short_name": "",
    "theme_color": "#1976d2",
    "background_color": "#fafafb",
    "display": "standalone",
    "scope": "",
    "start_url": "",
    "icons": [
      {
        "src": "assets/icons/icon-72x72.png",
        "sizes": "72x72",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-96x96.png",
        "sizes": "96x96",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-128x128.png",
        "sizes": "128x128",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-144x144.png",
        "sizes": "144x144",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-152x152.png",
        "sizes": "152x152",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-192x192.png",
        "sizes": "192x192",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-384x384.png",
        "sizes": "384x384",
        "type": "image/png",
        "purpose": "maskable any"
      },
      {
        "src": "assets/icons/icon-512x512.png",
        "sizes": "512x512",
        "type": "image/png",
        "purpose": "maskable any"
      }
    ]
  }

  accountConfig = {
      "smallDevices": {
        "showProfile": true,
        "showVerified": false,
        "showSpecialization": true,
        "showQualification": true,
        "showAbout": true,
        "showVirtualFields": true,
        "showCoverPicture": true,
        "showJaldeePopup": false
      },
      "normalDevices": {
        "showProfile": true,
        "showVerified": false,
        "showSpecialization": true,
        "showAbout": true,
        "showQualification": true,
        "showVirtualFields": true,
        "showCoverPicture": true,
        "showJaldeePopup": true
      },
      "iosApp": {
        "icon-180": {
          "src": "assets/icons/icon-180x180.png",
          "sizes": "180x180",
          "type": "image/png",
          "purpose": "maskable any"
        }
      }
  }
  accountDetails: any;
  pwaForm: UntypedFormGroup;
  formErrors = {
    'appName': '',
    'shortName': '',
    'themeColour': '',
    'bgColour': ''
  };
  ValidationMessages = {
    'appName': {
      'required': 'App Name is Required'
    },
    'shortName': {
      'required': 'Short Name is Required'
    },
    'bgColour': {
      'required': 'Backgroud color is Required'
    },
    'themeColour': {
      'required': 'Theme color is Required'
    }
  };
  ynwDomain: any;
  accountConfigUrl: any;
  assetsZip: File;
  constructor(
    private accountService: AccountService, 
    private activated_route: ActivatedRoute,
    private formbuilder: UntypedFormBuilder,
    private commonService: CommonfilterService
    ) { }

  ngOnInit() {
    this.commonService.getConfigData()
      .subscribe((config: any) => {
        // this.configData = config;
        // console.log('congifData' + JSON.stringify(this.configData));
        console.log('newUI');
        this.ynwDomain = config.ynwDomain;
      });
    this.accountDetails = this.activated_route.parent.snapshot.data['accountDetails'];
    console.log(this.accountDetails.account.id);
    console.log(this.accountDetails);
    this.pwaForm = this.formbuilder.group({
      appName: ['', [Validators.required]],
      shortName: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      themeColour: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      bgColour: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      theme: ['', []],
      privacy: ['', []],
      terms: ['', []],
      pixelId: ['', []]
    });

    this.pwaForm.patchValue({
      appName: this.accountDetails.account.businessName,
      shortName: this.accountDetails.account.businessName,
      themeColour: '#1976d2',
      bgColour: '#fafafa'
    })

    this.accountService.getPresignedUrlforPWA(this.accountDetails.account.id).subscribe(
      (urls) => {
        console.log(urls);
        this.manifestUrl = urls['manifestUrl'];
        this.assetsUrl = urls['assetUrl'];
        this.accountConfigUrl = urls['accountConfigUrl'];
      }
    );
  }

  onpwaSubmit() {
    const _this = this;
    const form_data = this.pwaForm.value;
    console.log(form_data);
    
    if (form_data['appName']) {
      this.manifestJson['name'] = form_data['appName'];
    }
    if (form_data['shortName']) {
      this.manifestJson['short_name'] = form_data['shortName'];
    }
    if (form_data['themeColour']) {
      this.manifestJson['theme_color'] = form_data['themeColour'];
    }
    if (form_data['bgColour']) {
      this.manifestJson['background_color'] = form_data['bgColour'];
    }
    this.manifestJson['scope'] =  this.ynwDomain + "/" + this.accountDetails.account.accEncUid;
    this.manifestJson['start_url'] =  this.ynwDomain + "/" + this.accountDetails.account.accEncUid;
    console.log(this.manifestJson);
    if (form_data['pixelId']) {
      this.accountConfig['pixelId'] = form_data['pixelId'];
    }
    this.accountConfig['pwaEnabled'] = true;

    this.accountConfig['homeUrl'] = 'customapp/' + this.accountDetails.account.accEncUid;
    this.accountConfig['uniqueId'] = this.accountDetails.account.uniqueId;
    this.accountConfig['providerId'] = this.accountDetails.account.id;
    this.accountConfig['version']= '1.0'


    // console.log(JSON.stringify(this.accountConfig));
    let manifestFile = new File([JSON.stringify(this.manifestJson)], 'manifest', { type: 'application/json',  lastModified: Date.now()});
    let accountConfigFile = new File([JSON.stringify(this.accountConfig)], 'account_config', { type: 'application/json',  lastModified: Date.now()});

    _this.uploadPWAFile(_this.manifestUrl, manifestFile).then(
      (manifestStatus) => {
        console.log(manifestStatus);
        _this.uploadPWAFile(_this.accountConfigUrl, accountConfigFile).then(
          (configStatus) => {
            console.log(configStatus);
            _this.uploadPWAFile(_this.assetsUrl, _this.assetsZip).then(
              (assetStatus) => {
                console.log(assetStatus);
                _this.extractS3Files(_this.accountDetails.account.id).then(
                  (extractStatus) => {
                    console.log(extractStatus);
                  }
                )
              });
          });
      }
    )
  }

  extractS3Files(accountId) {
    const _this = this;
    return new Promise(function (resolve, reject) {
      _this.accountService.extractPWAFiles(accountId).subscribe(
        (status)=>{
          resolve(true);
        }, (error)=> {
          resolve(false);
        }
      );
    });
  }

  uploadPWAFile(url, file) {
    const _this = this;
    return new Promise(function (resolve, reject) {
      _this.accountService.uploadPWAFiles(url, file).subscribe(
        (status)=>{
          resolve(true);
        }, (error)=> {
          resolve(false);
        }
      );
    });
  }

  handleFileInput(files: FileList) {
    this.assetsZip = files.item(0);
  }
  logValidationErrors(group: UntypedFormGroup = this.pwaForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }
}
